
// code for sms popup and landing custom page subscription code start here

var currency_selector = [];
var chz_cin = []; 
var x= document.getElementById("vodiapicker");

for(i=0; i<x.options.length;i++){
    var img = x.options[i].getAttribute("data-thumbnail");
    var text = x.options[i].innerText;
    var value = x.options[i].value;
    var item = '<li><img src="'+ img +'" alt="" value="'+value+'"/><span>'+ text +'</span></li>';
    var item_chz =  '<li><img src="'+ img +'" alt="" value="'+value+'"/><span> +1 </span></li>';
    chz_cin.push(item_chz)
    currency_selector.push(item);
}

for (var i = 0; i < currency_selector.length; i++) {  
    if (document.getElementById('a-currency'))
    {
        document.getElementById("a-currency").insertAdjacentHTML('beforeend',currency_selector[i]);  
    }  
    if (document.getElementById('a-currency-popup'))
    {
        document.getElementById("a-currency-popup").insertAdjacentHTML('beforeend',currency_selector[i]);  
    }        
}

document.querySelector(".current_currency_selected").innerHTML = chz_cin[0];
document.querySelector(".current_currency_selected").setAttribute('value', 'us');

var listItems_select_items = document.querySelectorAll(".form-currency-selector li"); // this returns an array of each li
var listItems_select = document.querySelector(".current_currency_selected");

    listItems_select.addEventListener("click", function(e) {    
        if (e.target.closest('.curre-select').querySelector('.b-currency').style.display !== 'block') {
            e.target.closest('.curre-select').querySelector('.b-currency').style.display = 'block';
        }
        else {
            e.target.closest('.curre-select').querySelector('.b-currency').style.display = 'none';
        }
    });


  listItems_select_items.forEach(function(i) {   
    i.onclick = function(event) {       
        var img =  i.querySelector('img').getAttribute('src');
        var value = i.querySelector('img').value;
        var item_chz =  '<li><img src="'+ img +'" alt="" value="'+value+'"/><span> +1 </span></li>';
        i.closest('.curre-select').querySelector(".current_currency_selected").innerHTML = item_chz;
        i.closest('.curre-select').querySelector(".current_currency_selected").setAttribute('value', value);
         if (i.closest('.curre-select').querySelector('.b-currency').style.display !== 'none') {
            i.closest('.curre-select').querySelector('.b-currency').style.display = 'none';
        }
        else {
            i.closest('.curre-select').querySelector('.b-currency').style.display = 'block';
        }   
    }
  });
  

function validatePhone(defaulselector) {
    var selector_click = defaulselector;    

    var a = $(selector_click).val();
    var filter = /^(0|91)?[2-9][0-9]{9}$/;  
    if (filter.test(a)) {
        $(selector_click).parents('.custom-subscription-form').find('.phone-error').hide();
        $(selector_click).parents('.custom-subscription-form').find('.submit-form-inupt-fields').removeClass('error-in-field');
        return true;        
    }
    else {
        $(selector_click).parents('.custom-subscription-form').find('.phone-error').show();
        $(selector_click).parents('.custom-subscription-form').find('.submit-form-inupt-fields').addClass('error-in-field');
        return false;        
    }
}

const phonevalidation = document.querySelector(".customer-phone-number");
phonevalidation.addEventListener("keyup", IsMobileNumber);
function IsMobileNumber() {
    var mob = /^(0|91)?[2-9][0-9]{9}$/; 
    let valid_email_status = true;
    if (mob.test(phonevalidation.value) == false) {
        phonevalidation.focus();
        phonevalidation.closest('.custom-subscription-form').querySelector('.phone-error').style.display = 'block';
        phonevalidation.closest('.submit-form-inupt-fields').classList.add('error-in-field')
        valid_email_status = false;
    }else{
        phonevalidation.closest('.custom-subscription-form').querySelector('.phone-error').style.display = 'none';
        phonevalidation.closest('.submit-form-inupt-fields').classList.remove('error-in-field')           
    }
    return valid_email_status;
}
let emailvalidation = "";
if (document.querySelector(".customer-email")){
    emailvalidation = document.querySelector(".customer-email");
    emailvalidation.addEventListener("keyup", validate_format_email);
}


const validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};
  
  function validate_format_email(){
    const email = emailvalidation.value;
    let valid_phone_status = true ;
    if(validateEmail(email)){
        emailvalidation.closest('.custom-subscription-form').querySelector('.email-error').style.display = 'none';
        emailvalidation.closest('.submit-form-inupt-fields').classList.remove('error-in-field')   
        
    } else{
        emailvalidation.focus();
        emailvalidation.closest('.custom-subscription-form').querySelector('.email-error').style.display = 'block';
        emailvalidation.closest('.submit-form-inupt-fields').classList.add('error-in-field')
        valid_phone_status = false;
    }
    return valid_phone_status;
  }
  




function form_validation(){
    var form_input_field_item = document.querySelectorAll(".field-main-object .check-input-field");
    let ddd = true ;
    form_input_field_item.forEach(function(i) {  
        var i_value = i.value; 
        if (i_value == null || i_value == "") {
            i.closest('.submit-form-inupt-fields').querySelector('.form-error-msg').style.display = 'block';
            i.closest('.submit-form-inupt-fields').classList.add('error-in-field');
             ddd = false;         
        }else{
            i.closest('.submit-form-inupt-fields').querySelector('.form-error-msg').style.display = 'none';
            i.closest('.submit-form-inupt-fields').classList.remove('error-in-field');       
        }
    })    
    return ddd;
}  

if(document.querySelectorAll('.field-main-object .check-input-field')){
    var dpr = document.querySelectorAll('.field-main-object .check-input-field');
    dpr.forEach(function(im) {  
        im.addEventListener("keyup", function(e){
            console.log(dpr.value);
                var im_val = im.value;
                if (im_val == null || im_val == "") {
                    im.closest('.submit-form-inupt-fields').querySelector('.form-error-msg').style.display = 'block';
                    im.closest('.submit-form-inupt-fields').classList.add('error-in-field');
                }else{
                    im.closest('.submit-form-inupt-fields').querySelector('.form-error-msg').style.display = 'none';
                    im.closest('.submit-form-inupt-fields').classList.remove('error-in-field');       
                }
        });
    })
}


// $('.customer-phone-number').on("keyup", function(){
//     var defaulselector = $(this)
//     validatePhone(defaulselector)  
// })

if (document.querySelector(".submit-signup-form")){
document.querySelector(".submit-signup-form").addEventListener("click", function(e) { 
    $(this).prop('disabled', true);     
    var inp_field_result = form_validation();
    var mobile_result = IsMobileNumber();
    var email_result = validate_format_email();
    var pnone_value = document.querySelector('.customer-phone-number').value;
    if(inp_field_result == true && mobile_result == true && email_result == true ){
        
        var tiktokname = e.target.closest('.custom-subscription-form').querySelector('#tiktokname').value;
        var instagramhandle = e.target.closest('.custom-subscription-form').querySelector('#instagramhandle').value;
        var ordernumber = e.target.closest('.custom-subscription-form').querySelector('#ordernumber').value;
        var email = e.target.closest('.custom-subscription-form').querySelector('#email').value;


        var country_phone = "+1"+pnone_value;

        let submit_data = {};

        if(e.target.classList.contains('car-giveaway')){
            var optin_no = 2            
        }
        else if(e.target.classList.contains('weight-loss-challenge')){
            var optin_no = 1;
            submit_data['weight'] = e.target.closest('.custom-subscription-form').querySelector('#weight').value;
        }
       
        if (document.getElementById('enable_message').checked) {
            var enable_text_marketing_msg = true;
        } else {
            var enable_text_marketing_msg = false;
        }
        
        submit_data['optin_id'] = optin_no;
        submit_data['tiktok_name'] = tiktokname;
        submit_data['instagram_handle'] = instagramhandle;
        submit_data['order_number'] = ordernumber;
        submit_data['email'] = email;
        submit_data['phone_number'] = country_phone;
        submit_data['enable_text_marketing_message'] = enable_text_marketing_msg;

        console.log(submit_data)

        let postformdata = JSON.stringify(submit_data)
        fetch("https://api.abn.simplesms.com/api/v1/shopify/welcome_work_flow", {
            method: 'post',
            body: postformdata,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
            }).then((response) => {
            return response.json()
            }).then((data) => {
                if(data.status == 1)   {
                    document.querySelector('.subscription-campaign-section').style.display = 'none';
                    document.querySelector('.subscription-success-section').style.display = 'block';

                } 
            }).catch((error) => {
                console.log(error)
            })
            

    }
  })
}

if (document.querySelector("#desktop-sms-popup")){
    document.querySelector("#desktop-sms-popup .subscription-success-section .custom-dev-button").addEventListener("click", function(e) {   
        setcookieforpopup();
    })
    document.querySelector("#desktop-sms-popup .popup-custom-close").addEventListener("click", function(e) {   
        setcookieforpopup();
    })
    document.querySelector(".minimized-popup-view").addEventListener("click", function(e) {   
        document.querySelector('#desktop-sms-popup').style.display = 'block';
        document.querySelector('#desktop-sms-popup').classList.add('show');
        document.querySelector('body').classList.add('modal-open');
        document.querySelector('.modal-backdrop').classList.add('show');
        document.querySelector('.modal-backdrop').style.display = 'block';           
        document.querySelector('#desktop-sms-popup').querySelector('#phone').value="";
        document.querySelector('.subscription-campaign-section').style.display = 'block';
        document.querySelector('.subscription-success-section').style.display = 'none'; 
    })    

    function setcookieforpopup(){
        document.querySelector('#desktop-sms-popup').style.display = 'none';
        document.querySelector('#desktop-sms-popup').classList.remove('show');
        document.querySelector('.modal-backdrop').classList.remove('show');
        document.querySelector('.modal-backdrop').style.display = 'none';
        document.querySelector('#desktop-sms-popup').querySelector('#phone').value="";
        document.querySelector('body').classList.remove('modal-open');           
        function setCookie(cname,cvalue,exdays) {
            const d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            let expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
          }
          setCookie("popup_opened", "true", 7);
    }
    

    document.querySelector(".popup-submit-signup-form").addEventListener("click", function(e) {
        $(this).prop('disabled', true);      
        var mobile_result = IsMobileNumber();
        var pnone_value = document.querySelector('.customer-phone-number').value;
        if(mobile_result == true){
                
            var country_phone = "+1"+pnone_value;
  
            let submit_data = {};
            submit_data['optin_id'] = 4;
            submit_data['phone_number'] = country_phone;
            console.log(submit_data)
    
            let postformdata = JSON.stringify(submit_data)
            fetch("https://api.abn.simplesms.com/api/v1/shopify/welcome_work_flow", {
                method: 'post',
                body: postformdata,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }
                }).then((response) => {
                return response.json()
                }).then((data) => {
                    function setCookie(cname,cvalue,exdays) {
                        const d = new Date();
                        d.setTime(d.getTime() + (exdays*24*60*60*1000));
                        let expires = "expires=" + d.toUTCString();
                        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
                      }
                      setCookie("popup_opened", "true", 7);
                    if(data.status == 1)   {
                        document.querySelector('.subscription-campaign-section').style.display = 'none';
                        document.querySelector('.subscription-success-section').style.display = 'block';
    
                    } 
                }).catch((error) => {
                    console.log(error)
                })
                
    
        }
      })

}
  
